import {
  getFinalMachConversion,
  getFinalMPHConversion,
  getFinalKnotsConversion,
  getFinalKPHConversion
} from "./SpeedConversionTracker";

function getConversion(val, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "ma":
      result = getFinalMachConversion(val, conType);
      break;
    case "mp":
      result = getFinalMPHConversion(val, conType);
      break;
    case "kn":
      result = getFinalKnotsConversion(val, conType);
      break;
    case "kp":
      result = getFinalKPHConversion(val, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
